import type { TypographyProps } from './Typography';
import { Typography } from './Typography';

export type TextHeroProps = Pick<
  TypographyProps,
  'label' | 'color' | 'uppercase' | 'ellipsis'
>;

export const TextHero = ({
  label,
  color = 'text-ds-natural',
  uppercase,
  ellipsis,
}: TextHeroProps) => (
  <Typography
    uppercase={uppercase}
    color={color}
    label={label}
    tagName="h1"
    fontSize="text-ds-900"
    lineHeight="leading-ds-800"
    fontWeight="font-ds-bold"
    ellipsis={ellipsis}
  />
);
